<template>
	<div class="job-complete-validator-tag">
		{{ validJobInfo.completedCount }} / {{ validJobInfo.totalJobsCount }}
	</div>
</template>

<script>
import { tseStepIsCompleted } from '../utils/tse.utils';

export default {
	name: 'job-complete-validator-tag',
	props: {
		jobs: {
			default: [],
		},
		jobValidator: {
			default: () => {},
		},
	},
	computed: {
		validJobInfo() {
			return tseStepIsCompleted(this.jobValidator, this.jobs);
		},
	},
};
</script>

<style lang="scss" scoped>
.job-complete-validator-tag {
	background-color: var(--app-color-primary);
	border-radius: 5px;
	position: absolute;
	top: -10px;
	right: 0;
	color: white;
	padding: 1px 10px;
	font-weight: bold;
	z-index: 9;
}
</style>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/commons/job-complete-validator-tag.vue